import React, { useState, type ReactNode } from 'react';
import { JSErrorBoundary } from '@jira/platform__js-error-boundary/src/JSErrorBoundary.tsx';
import { Stack } from '@atlaskit/primitives/compiled';
import UFOSegment from '@atlassian/jira-ufo-segment';
import SectionTitle from './SectionTitle.tsx';
import type { ProjectRecommendation, TabId } from './types.tsx';

type RecommendedProjectContainerProps = {
	children: ReactNode[];
	projectsDirectoryUrl: string;
	recommendedProjects: ProjectRecommendation[];
};

const RecommendedProjectsContainer = ({
	children,
	projectsDirectoryUrl,
	recommendedProjects,
}: RecommendedProjectContainerProps): React.ReactElement => {
	const [selectedTab, setSelectedTab] = useState<TabId>(
		recommendedProjects.length === 0 ? 'recent' : 'recommended',
	);

	return (
		<UFOSegment name="recommendedProjectsContainer">
			<JSErrorBoundary
				id="recommendedProjectsContainer"
				packageName="jiraGlobalPagesHomeProjectRecommendations"
				teamName="helios"
				fallback="flag"
			>
				<Stack space="space.100">
					<SectionTitle
						projectsDirectoryUrl={projectsDirectoryUrl}
						selectedTab={selectedTab}
						onSetSelectedTab={setSelectedTab}
					/>
					{selectedTab === 'recommended' && children[0]}
					{selectedTab === 'recent' && children[1]}
				</Stack>
			</JSErrorBoundary>
		</UFOSegment>
	);
};

export default RecommendedProjectsContainer;
